import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import {
  AuthxRecommendationsRedesignTestData,
  UseAuthxRecommendationsRedesign,
  AuthxRecommendationsRedesignVariants,
} from "./types";

const CUSTOM_RULE_ID = "authxRecommendationsRedesignTest";

const defaultData: AuthxRecommendationsRedesignTestData = {
  showRedesign: false,
};

const useAuthxRecommendationsRedesign: UseAuthxRecommendationsRedesign = (): {
  isLoading: boolean;
  variant: AuthxRecommendationsRedesignVariants;
  data: AuthxRecommendationsRedesignTestData;
} => {
  const { isLoading, value } =
    useMonarchRule<AuthxRecommendationsRedesignTestData>(CUSTOM_RULE_ID, {});

  const data: AuthxRecommendationsRedesignTestData = value ?? defaultData;

  if (isLoading) {
    return {
      isLoading,
      variant: "control",
      data,
    };
  }

  const variant: AuthxRecommendationsRedesignVariants = data.showRedesign
    ? "test"
    : "control";

  return {
    isLoading,
    variant,
    data,
  };
};

export default useAuthxRecommendationsRedesign;
